export class DocumentScriptLoader {
  public constructor(private readonly _document: Document) {}

  public load({ url, onLoad }: { url: string; onLoad: () => Promise<void> }) {
    const scriptElement = this._document.createElement('script')
    scriptElement.setAttribute('src', url)

    this._document.head.appendChild(scriptElement)
    scriptElement.addEventListener('load', onLoad)
  }
}
